/**
 * 日管控巡检项配置
 * 差异化项目可通过 projectId 覆盖默认检查项
 */

export const STATUS_OPTIONS = [
  { label: '正常', value: '正常' },
  { label: '异常', value: '异常' },
  { label: '不适用', value: '不适用' }
]

export const YES_NO_OPTIONS = [
  { label: '是', value: '是' },
  { label: '否', value: '否' }
]

export const SAFETY_STATUS_OPTIONS = [
  { label: '安全', value: '安全' },
  { label: '不安全', value: '不安全' }
]

export const SUMMARY_STATUS_FIELDS = [
  { key: 'equipmentStatus', label: '电梯设备运行状态', options: STATUS_OPTIONS },
  { key: 'internalSafetyStatus', label: '电梯内部安全情况', options: SAFETY_STATUS_OPTIONS },
  { key: 'externalSafetyStatus', label: '电梯外部安全情况', options: STATUS_OPTIONS },
  { key: 'communityEmergencyStatus', label: '楼层逃生通道情况', options: STATUS_OPTIONS }
]

export const DEFAULT_CHECKLIST_SECTIONS = [
  {
    key: 'doorStatus',
    title: '电梯开关门情况',
    items: [
      { key: 'doorSpeedNormal', label: '电梯开关门速度是否正常', type: 'select', options: YES_NO_OPTIONS },
      { key: 'doorCloseComplete', label: '电梯门的关闭是否完全', type: 'select', options: YES_NO_OPTIONS },
      { key: 'doorTrapRisk', label: '无存在夹人的危险', type: 'select', options: YES_NO_OPTIONS }
    ]
  },
  {
    key: 'controlPanel',
    title: '电梯控制面板和按钮操作情况',
    items: [
      { key: 'buttonsNormal', label: '电梯按钮是否正常', type: 'select', options: YES_NO_OPTIONS },
      { key: 'abnormalButtonFloor', label: '电梯异常所在楼层', type: 'input', placeholder: '无异常请填"无"', defaultValue: '无' },
      { key: 'floorDisplayNormal', label: '楼层显示是否正常', type: 'select', options: YES_NO_OPTIONS }
    ]
  },
  {
    key: 'startStop',
    title: '电梯运行情况',
    items: [
      { key: 'levelStop', label: '是否平层停止', type: 'select', options: YES_NO_OPTIONS },
      { key: 'shakeVibration', label: '轿厢运行不抖动震动', type: 'select', options: YES_NO_OPTIONS },
      { key: 'speedNormal', label: '速度是否正常', type: 'select', options: YES_NO_OPTIONS }
    ]
  },
  {
    key: 'internalSafety',
    title: '电梯内部安全情况',
    items: [
      { key: 'carLightingFan', label: '轿厢照明、风扇正常', type: 'select', options: YES_NO_OPTIONS },
      { key: 'emergencyLighting', label: '应急照明正常', type: 'select', options: YES_NO_OPTIONS },
      { key: 'alarmDevice', label: '轿内报警装置正常', type: 'select', options: YES_NO_OPTIONS },
      { key: 'intercom', label: '对讲系统是否正常', type: 'select', options: YES_NO_OPTIONS },
      { key: 'maintenanceSwitch', label: '轿厢检修开关正常', type: 'select', options: YES_NO_OPTIONS },
      { key: 'emergencyStopSwitch', label: '轿厢急停开关正常', type: 'select', options: YES_NO_OPTIONS },
      { key: 'antiSlipFloor', label: '轿厢地板是否防滑', type: 'select', options: YES_NO_OPTIONS },
      { key: 'carSignClear', label: '轿厢张贴标识是否清晰', type: 'select', options: YES_NO_OPTIONS }
    ]
  },
  {
    key: 'externalSafety',
    title: '电梯外部安全情况',
    items: [
      { key: 'surroundingsClean', label: '电梯周围是否干净无异物', type: 'select', options: YES_NO_OPTIONS },
      { key: 'pitWater', label: '底坑无渗水积水', type: 'select', options: YES_NO_OPTIONS },
      { key: 'pitLighting', label: '底坑照明正常', type: 'select', options: YES_NO_OPTIONS },
      { key: 'hoistwayLighting', label: '井道照明正常', type: 'select', options: YES_NO_OPTIONS },
      { key: 'machineRoomEnv', label: '机房环境是否良好', type: 'select', options: YES_NO_OPTIONS },
      { key: 'emergencyDevices', label: '手动紧急装置是否齐全', type: 'select', options: YES_NO_OPTIONS },
      { key: 'uncivilizedBehavior', label: '无不文明乘梯行为', type: 'select', options: YES_NO_OPTIONS },
      { key: 'overload', label: '未出现超载情况', type: 'select', options: YES_NO_OPTIONS }
    ]
  },
  {
    key: 'managedEquipment',
    title: '托管配套设备',
    items: [
      { key: 'monitorAngle', label: '监控角度是否正常', type: 'select', options: YES_NO_OPTIONS },
      { key: 'sdCardStatus', label: 'SD卡/物联卡是否正常', type: 'select', options: YES_NO_OPTIONS },
      { key: 'upsStatus', label: 'UPS电源是否正常', type: 'select', options: YES_NO_OPTIONS },
      { key: 'alarmDeviceStatus', label: '报警装置是否正常', type: 'select', options: YES_NO_OPTIONS }
    ]
  },
  {
    key: 'machineRoom',
    title: '机房',
    items: [
      { key: 'machineRoomEnvironment', label: '机房环境是否良好', type: 'select', options: YES_NO_OPTIONS },
      { key: 'machineRoomDoorLighting', label: '机房门窗、灯照明是否正常', type: 'select', options: YES_NO_OPTIONS },
      { key: 'machineRoomVentilator', label: '排风扇是否正常', type: 'select', options: YES_NO_OPTIONS },
      { key: 'machineRoomTemperature', label: '机房温度是否正常', type: 'select', options: YES_NO_OPTIONS }
    ]
  }
]

/**
 * 项目差异化配置示例
 * key 为项目 id，value 为完整 sections 或 partial override
 */
export const PROJECT_CHECKLIST_OVERRIDES = {
  // 示例：'123': { sections: [...] }
}

export function getChecklistSections(projectId) {
  const override = PROJECT_CHECKLIST_OVERRIDES[projectId]
  if (override && override.sections) {
    return override.sections
  }
  return DEFAULT_CHECKLIST_SECTIONS
}

/** 页面三列网格定位：与导出列对齐 */
export const CHECKLIST_GRID_PLACEMENT = {
  doorStatus: { row: 1, col: 1 },
  controlPanel: { row: 1, col: 2 },
  startStop: { row: 1, col: 3 },
  internalSafety: { row: 2, col: 1 },
  externalSafety: { row: 2, col: 2 }
}

/** 右侧合并展示（托管配套设备 + 机房） */
export const CHECKLIST_RIGHT_STACK_KEYS = ['managedEquipment', 'machineRoom']
export const CHECKLIST_RIGHT_STACK_PLACEMENT = { row: 2, col: 3 }

export function getChecklistGridLayout(projectId) {
  const sections = getChecklistSections(projectId)
  const byKey = Object.fromEntries(sections.map((s) => [s.key, s]))

  const mainSections = sections
    .filter((section) => !CHECKLIST_RIGHT_STACK_KEYS.includes(section.key))
    .map((section) => {
      const placement = CHECKLIST_GRID_PLACEMENT[section.key] || { row: 1, col: 1 }
      return {
        ...section,
        gridRow: placement.row,
        gridCol: placement.col
      }
    })

  const rightStackSections = CHECKLIST_RIGHT_STACK_KEYS
    .map((key) => byKey[key])
    .filter(Boolean)

  return {
    mainSections,
    rightStackSections,
    rightStackPlacement: CHECKLIST_RIGHT_STACK_PLACEMENT
  }
}

export function createDefaultFormValues(sections) {
  const values = {
    equipmentStatus: '正常',
    internalSafetyStatus: '安全',
    externalSafetyStatus: '正常',
    communityEmergencyStatus: '正常',
    logDescription: ''
  }
  sections.forEach((section) => {
    section.items.forEach((item) => {
      values[item.key] =
        item.type === 'input' ? (item.defaultValue !== undefined ? item.defaultValue : '') : '是'
    })
  })
  return values
}
